import { left } from 'icons/left';
import { maximize } from 'icons/maximize';

import { CSS_COLORS } from 'consts/consts';
import { BOT_MODE } from 'consts/enum';
import { ENGT_CHAT } from 'js/bot.model';

import './sourcePreviewHeader.scss';

export const SourcePreviewHeaderTemplate = (model) => {
	const { title } = model;
	const isStandalone = ENGT_CHAT.get('config.bot_mode') === BOT_MODE.STANDALONE;

	const backBtn = `
		<div class="engt-source-preview-back engt-tab-selectable" tabindex="0" onkeydown="ENGT_CHAT.onEnterPress()">${left(
			CSS_COLORS.THEME_TEXT_COLOR
		)}</div>
	`;

	const maximizeBtn = `
		<div role="button" 
		tabindex="0" 
		class="engt-maximize-screen engt-tab-selectable"
		id="engtMaximizeScreen"
		onkeydown="ENGT_CHAT.onEnterPress()"
	    >
		${maximize()}
    </div>
	`;

	const html = `
    <div class="back-btn-container">
        ${backBtn}
    </div>
    <div class="title-container">
        <span>${title}</span>
    </div>
    <div class="maximize-btn-container">
        ${ENGT_CHAT.get('isMobileOrTablet') || isStandalone ? '' : maximizeBtn}
    </div>
`;

	return html;
};
